const TEMPLATES = {
  "recipe": `
    <blockquote>This is one of my favorite recipes...</blockquote>
    <h2>Ingredients</h2>
    <ul>
      <li>Ingredient 1</li>
      <li>Ingredient 2</li>
      <li>Ingredient 3</li>
    </ul>
    <h2>Directions</h2>
    <ol>
      <li>First...</li>
      <li>Then...</li>
      <li>Lastly...</li>
    </ol>
  `,
  "workout": `
    <blockquote>This workout is great to do at the house if you have a break during the day.</blockquote>
    <h2>Equipment Needed</h2>
    <ul>
      <li>Yoga Mat</li>
      <li>Light weights (5-15 lbs)</li>
      <li>Kettlebell</li>
    </ul>
    <h2>Circuit (Repeat 3X with 90 second rest in between)</h2>
    <ol>
      <li>10 reps of...</li>
      <li>10 reps each side of...</li>
      <li>20 reps of...</li>
      <li>Repeat</li>
    </ol>
  `
}

export default TEMPLATES
